const DEFAULT_ALLOWED_HOST_PATTERNS = [/\.reef2reef\.com$/i, /^localhost$/i];

/**
 * @param {string} url
 * @param {RegExp[]} [allowedHostPatterns]
 */
const isAllowedForumThreadUrl = (url, allowedHostPatterns = DEFAULT_ALLOWED_HOST_PATTERNS) => {
  try {
    const parsed = new URL(String(url).trim());
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      return false;
    }
    return allowedHostPatterns.some(pattern => pattern.test(parsed.hostname));
  } catch (_) {
    return false;
  }
};

export default isAllowedForumThreadUrl;
